import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import cross from "../assets/img/cross.svg";
import TalkingPreview from "./TalkingPreview";
import { toast } from "react-toastify";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { addTalkingBadge } from "store/actions/talkingBadgeAction";
import { getVoteGetterBadge } from "store/actions/talkingBadgeAction";
import ReuseableTable from "./Tables/ReuseableTable";

const HonorBadge = ({ toggle, addModal, Id, winnerQrCode }) => {
  let dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const [btnLoader, setBtnLoader] = useState(false);
  const [qrCodePrice, setqrCodePrice] = useState("");
  const [formData, setFormData] = useState({
    introducingVideo: null,
    appealingVideo: null,
    amount: qrCodePrice,
    athleteId: uid,
    athleteID: user.athleteID,
    description: "",
    type: "honor_badge",
  });

  const { votegetterBadges } = useSelector((state) => state.talkingBadges);

  const [showCustomPriceInput, setShowCustomPriceInput] = useState(false);

  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg",
      ];
      if (validImageTypes.includes(file.type)) {
        setFormData((prevData) => ({
          ...prevData,
          [fieldName]: file,
        }));
      } else {
        toast.error("Invalid file type. Please select a valid image file.");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let NewData = {
      ...formData,
      contestId: Id,
    };
    if (NewData.amount == "") {
      toast.warning("Please Enter Badge Card Price");
    } else {
      setBtnLoader(true);
      await dispatch(
        addTalkingBadge(NewData, () => {
          toast.success("Create Badge Successfully");
          toggle();
          setqrCodePrice("");
          setBtnLoader(false);
          resetFormData();
          setShowCustomPriceInput(false);
        })
      );
    }
  };

  const resetFormData = () => {
    setqrCodePrice("");
    setFormData({
      introducingVideo: null,
      appealingVideo: winnerQrCode,
      amount: qrCodePrice,
      athleteId: user.id,
      athleteID: user.athleteID,
      description: "",
      type: "honor_badge",
    });
  };

  const data = {
    athleteImg: user?.player_image?.url,
    firstName: user?.first_name,
    lastName: user?.last_name,
    introducingVideo: formData.introducingVideo,
    appealingVideo: formData.appealingVideo,
    description: formData.description,
  };

  useEffect(() => {
    let obj = {
      athleteId: uid,
      contestId: Id,
    };
    dispatch(getVoteGetterBadge(obj, () => {}));
  }, [Id]);

  useEffect(() => {
    resetFormData();
  }, [toggle]);
  const TABLE_DATA = {
    columns: ["CreatedAt", "Price", "Introducing Image", "Appealing Video"],
    keyMap: {
      CreatedAt: "CreatedAt",
      Price: "Price",
      "Introducing Image": "Introducing Image",
      "Appealing Video": "Appealing Video",
    },
    data:
      votegetterBadges.length > 0
        ? votegetterBadges.map((item) => {
            return {
              CreatedAt: moment
                .unix(item?.createdAt?.seconds)
                .format("D MMM YYYY"),
              Price: `$${item?.amount}`,
              "Introducing Image": (
                <img src={item?.introducingImageUrl} height={50} width={50} />
              ),
              "Appealing Video": (
                <img src={item?.appealingVideoUrl} height={50} width={50} />
              ),
            };
          })
        : [
            {
              CreatedAt: "N/A",
              Price: "N/A",
              "Introducing Image": "N/A",
              "Appealing Video": "N/A",
            },
          ],
  };

  return (
    <Modal isOpen={addModal} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Create Honor Badge</ModalHeader>
      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(e);
          }}
        >
          <Row className="d-flex justify-content-center">
            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">Add Description</Label>
                <Input
                  required
                  id="appealingVideo"
                  name="description"
                  type="text"
                  placeholder="Enter Description"
                  value={formData.description}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 14) {
                      setFormData((prevData) => ({
                        ...prevData,
                        description: inputValue,
                      }));
                    } else {
                      toast.error("Only 14 characters are allowed");
                    }
                  }}
                />
              </FormGroup>
            </Col>
            <Col className="col-sm-6 col-6">
              <FormGroup>
                <Label for="exampleSelect">Online Badge Card Price</Label>
                <Input
                  id="exampleSelect"
                  name="select"
                  type="select"
                  value={qrCodePrice}
                  onChange={(e) => {
                    setqrCodePrice(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      amount: e.target.value,
                    }));
                    if (e.target.value === "custom") {
                      setShowCustomPriceInput(true);
                    } else {
                      setShowCustomPriceInput(false);
                    }
                  }}
                >
                  <option value="">--Select Price--</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="custom">Custom Value</option>
                </Input>
                {showCustomPriceInput && (
                  <Input
                    required
                    className="mt-2"
                    type="number"
                    placeholder="Enter Custom Value"
                    value={qrCodePrice}
                    onChange={(e) => {
                      setqrCodePrice(e.target.value);
                      setFormData((prevData) => ({
                        ...prevData,
                        amount: e.target.value,
                      }));
                    }}
                    min={17}
                    max={1000}
                  />
                )}
              </FormGroup>{" "}
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="introducingVideo">
                  QR Code introduce self Video
                </Label>
                {formData.introducingVideo && (
                  <div className="position-relative">
                    <img
                      src={URL.createObjectURL(formData.introducingVideo)}
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      required
                      style={{
                        top: "-11%",
                        left: "22%",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData((prevData) => ({
                          ...prevData,
                          introducingVideo: null,
                        }))
                      }
                    />
                  </div>
                )}
                {!formData.introducingVideo && (
                  <Input
                    id="introducingVideo"
                    name="introducingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "introducingVideo")}
                    required
                  />
                )}
              </FormGroup>
            </Col>

            <Col className="col-sm-6 col-6">
              <FormGroup className="d-flex flex-column">
                <Label for="appealingVideo">QR Code entertainment Video</Label>
                {formData.appealingVideo && (
                  <div className="position-relative">
                    <img
                      src={
                        formData.appealingVideo
                          ? URL.createObjectURL(formData.appealingVideo)
                          : ""
                      }
                      alt=""
                      className="mb-3"
                      width={80}
                      height={80}
                      required
                    />

                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      required
                      style={{
                        top: "-11%",
                        left: "22%",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setFormData((prevData) => ({
                          ...prevData,
                          appealingVideo: null,
                        }))
                      }
                    />
                  </div>
                )}
                {!formData.appealingVideo && (
                  <Input
                    required
                    id="appealingVideo"
                    name="appealingVideo"
                    type="file"
                    accept=".jpg, .jpeg, .svg, .png"
                    onChange={(e) => handleImageChange(e, "appealingVideo")}
                  />
                )}
              </FormGroup>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Button color="primary" type="submit">
              {btnLoader ? <Spinner size="sm" /> : "Create Badge"}
            </Button>
          </Row>
        </Form>
        <Row className="d-flex justify-content-center">
          <Card className="col-lg-6 col-md-8 col-sm-8 mb-3 mt-5 mx-2">
            <TalkingPreview data={data} />
          </Card>
        </Row>
        {votegetterBadges?.length > 0 ? (
          <Card>
            <ReuseableTable {...TABLE_DATA} />
          </Card>
        ) : (
          <p className="text-center mt-3">No Badge Exists</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default HonorBadge;
